const API_ENDPOINT = window.apiUrl + "/api/product/filter";

// State management
let currentState = {
  filters: {
    collection: [collectionHandle],
  },
  sortBy: "rank",
  sortOrder: "desc",
  cursor: null,
  isLoading: false,
  direction: null,
};

// Sort buttons
document.querySelectorAll(".sort-btn").forEach((btn, index) => {
  btn.addEventListener("click", function () {
    document
      .querySelectorAll(".sort-btn")
      .forEach((b) => b.classList.remove("active"));
    this.classList.add("active");

    // Map sort buttons to API values
    switch (index) {
      case 0: // 人気順 - rank
        currentState.sortBy = "rank";
        currentState.sortOrder =
          currentState.sortOrder === "asc" ? "desc" : "asc";
        break;
      case 1: // 価格 - price
        currentState.sortBy = "min_price";
        currentState.sortOrder =
          currentState.sortOrder === "asc" ? "desc" : "asc";
        break;
      case 2: // サイズ - size
        currentState.sortBy = "number_size";
        currentState.sortOrder =
          currentState.sortOrder === "asc" ? "desc" : "asc";
        break;
    }

    // Update icon rotation for sort
    const sortIcon = this.querySelector(".sort-icon");
    if (sortIcon) {
      if (currentState.sortOrder === "asc") {
        sortIcon.classList.add("asc");
      } else {
        sortIcon.classList.remove("asc");
      }
    }

    // Re-fetch with new sort
    loadProducts(true);
  });
});

// Pagination buttons
const prevButtons = document.querySelectorAll(".pagination-prev");
const nextButtons = document.querySelectorAll(".pagination-next");

prevButtons.forEach((btn) => {
  btn.addEventListener("click", () => {
    if (!btn.disabled && !currentState.isLoading) {
      loadPreviousPage();
    }
  });
});

nextButtons.forEach((btn) => {
  btn.addEventListener("click", () => {
    if (!btn.disabled && !currentState.isLoading) {
      loadNextPage();
    }
  });
});

// Main function to load products
async function loadProducts(resetPagination = false) {
  if (currentState.isLoading) return;

  currentState.isLoading = true;

  if (resetPagination) {
    currentState.cursor = null;
  }

  try {
    const requestData = {
      collection: currentState.filters.collection,
      sortBy: currentState.sortBy,
      sortOrder: currentState.sortOrder,
      cursor: currentState.cursor,
      direction: currentState.direction,
    };

    // Update URL with current state
    updateURLParams(requestData);

    const result = await getProductsWithFilter(requestData);

    if (result.success) {
      renderProducts(result.data.products);
      updatePagination(result.data.pagination);
      updateProductsHeader(
        result.data.pagination.display.currentPage,
        result.data.pagination.display.totalPages,
      );

      // Store cursors for pagination
      currentState.nextCursor = result.data.pagination.nextCursor;
      currentState.previousCursor = result.data.pagination.previousCursor;
    } else {
      showError(result.error);
    }
  } catch (error) {
    showError("商品の読み込みに失敗しました: " + error.message);
  } finally {
    currentState.isLoading = false;
  }
}

async function loadNextPage() {
  if (currentState.nextCursor) {
    currentState.cursor = currentState.nextCursor;
    currentState.direction = "next";
    await loadProducts(false);
  }
}

async function loadPreviousPage() {
  if (currentState.previousCursor) {
    currentState.cursor = currentState.previousCursor;
    currentState.direction = "prev";
    await loadProducts(false);
  }
}

// API call function
async function getProductsWithFilter(formData) {
  showLoading();
  try {
    const response = await fetch(API_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      const result = await response.json();
      return { success: true, data: result };
    } else {
      let errorData = {};
      try {
        errorData = await response.json();
      } catch (e) {}

      const errorMessage =
        errorData.message ||
        `HTTP Error: ${response.status} ${response.statusText}`;
      return {
        success: false,
        error: errorMessage,
      };
    }
  } catch (error) {
    return {
      success: false,
      error: `Network error: ${error.message}`,
    };
  } finally {
    closeLoading();
  }
}

// UI rendering functions
function renderProducts(products) {
  const productsContainer = document.querySelector("#collection-product-list");
  const productsSection = document.querySelector(".products-list");
  const noResultsDiv = document.querySelector("#no-results-message");
  const paginationEnd = document.querySelector("#pagination-end");

  if (!productsContainer || !productsSection) return;

  // Clear existing content
  productsContainer.innerHTML = "";

  // Check if no products
  if (!products || products.length === 0) {
    // Hide products section
    productsSection.classList.add("d-none");
    noResultsDiv.classList.remove("d-none");
    productsContainer.innerHTML = "";
    return;
  }

  // Show products section if hidden
  productsSection.classList.remove("d-none");
  noResultsDiv.classList.add("d-none");
  paginationEnd.classList.add("d-none");

  const fragment = document.createDocumentFragment();

  // Render products
  products.forEach(({ node }) => {
    const div = document.createElement("div");
    div.className = "h-100";
    div.innerHTML = `
                <div class="product-item h-100" data-product-id="${node.id}">
                    <div class="card h-100 position-relative">
                        <a href="/products/${node.handle}" class="card-link text-decoration-none">
                            <img src="${node.image}" class="product-img" alt="${node.title}" width="" height="">
                            <div class="card-body">
                                <div class="product-info text-center">
                                    <div class="product-name">${node.title}</div>
                                    <div class="product-price">
                                        <span class="price-symbol num">1点(税込)</span>
                                        <span class="price-amount num">${node.minPrice ? node.minPrice : ""}</span>
                                        <span class="price-unit">円〜</span>
                                    </div>
                                </div>
                            </div>
                        </a>
                        <button class="favorite-btn position-absolute top-2 end-2" data-product-id="${normalizeProductId(node.id)}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" class="bi bi-heart　cls-1"
                                viewBox="0 0 25.02 20.1">
                                <defs>
                                    <style>
                                        .cls-1 {
                                            fill: #d3d3d3;
                                        }
                                    </style>
                                </defs>
                                <g id="main">
                                    <path class="cls-1"
                                        d="M13.65,19.73c-.68.49-1.59.49-2.27,0l-2.68-1.93c-.07-.05-1.74-1.26-3.43-2.72-1.11-.96-2-1.82-2.71-2.62-.63-.72-2.56-2.91-2.56-5.94C0,2.92,2.92,0,6.52,0c2.69,0,4.99,1.62,5.99,3.94,1-2.32,3.31-3.94,5.99-3.94,3.6,0,6.52,2.92,6.52,6.52,0,3.03-1.92,5.22-2.56,5.94-.71.8-1.59,1.66-2.71,2.62-1.69,1.45-3.36,2.66-3.43,2.72l-2.68,1.93Z" />
                                </g>
                            </svg>
                        </button>
                </div>
        `;
    fragment.appendChild(div);
  });

  setTimeout(() => {
    productsContainer.innerHTML = "";
    productsContainer.appendChild(fragment);
    paginationEnd.classList.remove("d-none");
    attachFavoriteListeners();
  }, 100);
}

function updatePagination(paginationData) {
  const prevButtons = document.querySelectorAll(".pagination-prev");
  const nextButtons = document.querySelectorAll(".pagination-next");

  prevButtons.forEach((btn) => {
    btn.disabled = !paginationData.hasPreviousPage;
    btn.classList.toggle("disabled", !paginationData.hasPreviousPage);
  });

  nextButtons.forEach((btn) => {
    btn.disabled = !paginationData.hasNextPage;
    btn.classList.toggle("disabled", !paginationData.hasNextPage);
  });
}

function updateProductsHeader(currentPage, totalPages) {
  const productCount = document.querySelectorAll(".product-count");
  productCount.forEach((subtitle) => {
    if (subtitle) {
      subtitle.textContent = `ページ: ${currentPage} / ${totalPages}`;
    }
  });
}

// Utility functions

function showError(message) {
  alert("エラー: " + message);
}

// Initialize from URL parameters
function initializeFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  let hasParams = false;

  // Initialize sort parameters
  const sortBy = urlParams.get("sortBy");
  if (sortBy) {
    currentState.sortBy = sortBy;
    hasParams = true;
  }

  const sortOrder = urlParams.get("sortOrder");
  if (sortOrder) {
    currentState.sortOrder = sortOrder;
    hasParams = true;
  }

  const cursor = urlParams.get("cursor");
  if (cursor) {
    currentState.cursor = cursor;
    hasParams = true;
  }

  const direction = urlParams.get("direction");
  if (direction) {
    currentState.direction = direction;
    hasParams = true;
  }

  if (hasParams) {
    syncUIWithState();
    return true;
  }

  return false;
}

// Function to sync UI elements with current state
function syncUIWithState() {
  // Sync sort buttons
  document.querySelectorAll(".sort-btn").forEach((btn, index) => {
    btn.classList.remove("active");

    let shouldBeActive = false;
    switch (index) {
      case 0: // 人気順 - rank
        shouldBeActive = currentState.sortBy === "rank";
        break;
      case 1: // 価格 - price
        shouldBeActive = currentState.sortBy === "min_price";
        break;
      case 2: // サイズ - size
        shouldBeActive = currentState.sortBy === "number_size";
        break;
    }

    if (shouldBeActive) {
      btn.classList.add("active");

      // Update icon
      const sortIcon = btn.querySelector(".sort-icon");
      if (sortIcon) {
        if (currentState.sortOrder === "asc") {
          sortIcon.classList.add("asc");
        } else {
          sortIcon.classList.remove("asc");
        }
      }
    }
  });
}

// Function to update URL parameters
function updateURLParams(requestData) {
  const url = new URL(window.location);
  const params = new URLSearchParams();

  // Handle other parameters
  if (requestData.sortBy) {
    params.set("sortBy", requestData.sortBy);
  }

  if (requestData.sortOrder) {
    params.set("sortOrder", requestData.sortOrder);
  }

  if (requestData.cursor) {
    params.set("cursor", requestData.cursor);
  }

  if (requestData.direction) {
    params.set("direction", requestData.direction);
  }

  // Update URL without page reload
  url.search = params.toString();
  window.history.pushState({}, "", url.toString());
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", function () {
  // Auto-load products
  loadProducts(true);

  // Initialize from URL or use defaults
  initializeFromURL();
});
